
import {
  Component, Prop, Watch, Vue,
} from 'vue-property-decorator';
import { AvailableService, deliveryTimeFormattedType } from '@/features/shipment/types';
import { getDeliveryDateAndTime, getPrice } from '@/features/common/helpers';
import { getCarrierLogoCode, getDisplayCarrierCode } from '@/features/common/helpers/carrier';
import ServiceItemDetails from './ServiceItemDetails.vue';

@Component({
  components: {
    ServiceItemDetails,
  },
})
export default class ServiceItem extends Vue {
  private showExpand = false;

  @Watch('showExpand')
  private onExpand(expanded: boolean): void {
    if (expanded) this.$emit('expand', this.service);
  }

  @Prop({ required: true }) service!: AvailableService;

  @Prop({ default: false }) isReceiversAcc!: boolean;

  @Prop({ default: false }) selected!: boolean;

  @Prop({ default: false }) isCheapest!: boolean;

  @Prop({ default: false }) isFastest!: boolean;

  get deliveryDateAndTime(): deliveryTimeFormattedType {
    return getDeliveryDateAndTime(this.service.deliveryTime);
  }

  get otherTags(): string[] {
    if (!this.service.tags || !Array.isArray(this.service.tags)) {
      return [];
    }

    return this.service.tags.filter((tag) => {
      const lowerTag = tag.toLowerCase();
      return lowerTag !== 'cheapest' && lowerTag !== 'fastest';
    });
  }

  private getPrice = getPrice;

  private getCarrierLogoCode = getCarrierLogoCode;

  private getDisplayCarrierCode = getDisplayCarrierCode;
}
